import enLocale from 'element-ui/lib/locale/lang/en';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';
import trLocale from 'element-ui/lib/locale/lang/tr-TR';
import ptLocale from 'element-ui/lib/locale/lang/pt';
import plLocale from 'element-ui/lib/locale/lang/pl';
import deLocale from 'element-ui/lib/locale/lang/de';
import frLocale from 'element-ui/lib/locale/lang/fr';
import esLocale from 'element-ui/lib/locale/lang/es';
import daLocale from 'element-ui/lib/locale/lang/da';
import arLocale from 'element-ui/lib/locale/lang/ar';
import noLocale from 'element-ui/lib/locale/lang/nb-NO';
import itLocale from 'element-ui/lib/locale/lang/it';
import roLocale from 'element-ui/lib/locale/lang/ro';

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { cloneDeep } from 'lodash';

import en from './en.json';
import enExtra from './en_extra.json';

import tr from './tr.json';
import trExtra from './tr_extra.json';

import ru from './ru.json';
import ruExtra from './ru_extra.json';

import pt from './pt.json';
import ptExtra from './pt_extra.json';

import pl from './pl.json';
import plExtra from './pl_extra.json';

import de from './de.json';
import deExtra from './de_extra.json';

import fr from './fr.json';
import frExtra from './fr_extra.json';

import es from './es.json';
import esExtra from './es_extra.json';

import da from './da.json';
import daExtra from './da_extra.json';

import ar from './ar.json';
import arExtra from './ar_extra.json';

import no from './no.json';
import noExtra from './no_extra.json';

import nb from './nb.json';
import nbExtra from './nb_extra.json';

import nn from './nn.json';
import nnExtra from './nn_extra.json';

import it from './it.json';
import itExtra from './it_extra.json';

import ro from './ro.json';
import roExtra from './ro_extra.json';

Vue.use(VueI18n);

export const getDefaultMessages = () => cloneDeep({
  en: { ...en, ...enExtra, ...enLocale },
  tr: { ...tr, ...trExtra, ...trLocale },
  ru: { ...ru, ...ruExtra, ...ruLocale },
  pt: { ...pt, ...ptExtra, ...ptLocale },
  pl: { ...pl, ...plExtra, ...plLocale },
  de: { ...de, ...deExtra, ...deLocale },
  fr: { ...fr, ...frExtra, ...frLocale },
  es: { ...es, ...esExtra, ...esLocale },
  da: { ...da, ...daExtra, ...daLocale },
  ar: { ...ar, ...arExtra, ...arLocale },
  no: { ...no, ...noExtra, ...noLocale },
  nb: { ...nb, ...nbExtra, ...noLocale },
  nn: { ...nn, ...nnExtra, ...noLocale },
  it: { ...it, ...itExtra, ...itLocale },
  ro: { ...ro, ...roExtra, ...roLocale }
});

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: getDefaultMessages(),
  silentTranslationWarn: true // Console Warning Hide.

});

export default i18n;
